import React, { FC } from 'react';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import SplitModuleContainer from '../@shared/splitModuleContainer';
import { SplitModuleContainerProps } from '../@shared/splitModuleContainer/types/splitModuleContainer.types';
import { SplitModuleContainerModel } from '../@shared/splitModuleContainer/models/splitModuleContainer.model';
import { ComponentConsumerProps, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const SplitModule: FC<ComponentConsumerProps & SplitModuleContainerProps> = (props) => {
  const model = new SplitModuleContainerModel(props);

  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }
  return <SplitModuleContainer {...props} />;
};

export default withSitecoreContext()(SplitModule);
